import { BiddingData } from 'store/modules/bidding_store/types';
import { ProfileData } from 'store/modules/profile_store/types';
import { buildFidelizeFormQuote } from 'services/conlicitaseg';
import {
  ConlicitasegTypes,
  InsuranceQuote,
  InsuranceCompany,
  FormProcessData,
  InsuranceProcess,
  SubimitQuote,
  QuoteFlow,
  GuaranteeType,
  OriginChannel,
} from './types';

export const getQuotes = () => ({
  types: [
    ConlicitasegTypes.GET_QUOTES_REQUEST,
    ConlicitasegTypes.GET_QUOTES_SUCCESS,
    ConlicitasegTypes.GET_QUOTES_FAILURE,
  ],
  promise: (client: any) => client.get('/conlicitaseg/insurance_processes'),
});

export const getQuoteById = (id: number) => ({
  types: [
    ConlicitasegTypes.GET_QUOTE_BY_ID_REQUEST,
    ConlicitasegTypes.GET_QUOTE_BY_ID_SUCCESS,
    ConlicitasegTypes.GET_QUOTE_BY_ID_FAILURE,
  ],
  promise: (client: any) => client.get(`/conlicitaseg/insurance_quotes/${id}`),
});

export const getBiddingGuaranteeData = (bidding_id: number, type_warranty: string) => ({
  types: [
    ConlicitasegTypes.GET_BIDDING_GUARANTEE_DATA_REQUEST,
    ConlicitasegTypes.GET_BIDDING_GUARANTEE_DATA_SUCCESS,
    ConlicitasegTypes.GET_BIDDING_GUARANTEE_DATA_FAILURE,
  ],
  type_warranty,
  promise: (client: any) =>
    client.get('/conlicitaseg/insurance_quotes/get_bidding_guarantee', {
      params: { bidding_id },
    }),
});

export const getFidelizeBiddingGuarantee = (
  bidding: BiddingData,
  profile: ProfileData,
  { markAutofill = true }: { markAutofill?: boolean } = {},
) => ({
  types: [
    ConlicitasegTypes.GET_FIDELIZE_BIDDING_GUARANTEE_REQUEST,
    ConlicitasegTypes.GET_FIDELIZE_BIDDING_GUARANTEE_SUCCESS,
    ConlicitasegTypes.GET_FIDELIZE_BIDDING_GUARANTEE_FAILURE,
  ],
  fidelize_fallback: buildFidelizeFormQuote(bidding, profile),
  mark_autofill: markAutofill,
  promise: (client: any) =>
    client.get('/conlicitaseg/insurance_quotes/get_bidding_guarantee', {
      params: { bidding_id: bidding?.id },
    }),
});

export const setFormQuote = (form: Partial<FormProcessData>) => ({
  type: ConlicitasegTypes.SET_FORM_QUOTE,
  payload: form,
});

export const setAutofilledFields = (data: Record<string, unknown>) => ({
  type: ConlicitasegTypes.SET_AUTOFILLED_FIELDS,
  payload: data,
});

export const setQuoteFlow = (flow: QuoteFlow, guaranteeType: GuaranteeType = null) => ({
  type: ConlicitasegTypes.SET_QUOTE_FLOW,
  payload: { flow, guaranteeType },
});

export const setOriginChannel = (channel: OriginChannel) => ({
  type: ConlicitasegTypes.SET_ORIGIN_CHANNEL,
  payload: channel,
});

export const consumeFidelizeLoginRedirect = () => ({
  type: ConlicitasegTypes.CONSUME_FIDELIZE_LOGIN_REDIRECT,
});

export const markFidelizeEmailLinkApplied = () => ({
  type: ConlicitasegTypes.MARK_FIDELIZE_EMAIL_LINK_APPLIED,
});

export const setContractUploaded = (uploaded: boolean) => ({
  type: ConlicitasegTypes.SET_CONTRACT_UPLOADED,
  payload: uploaded,
});

export const clearFormQuote = () => ({
  type: ConlicitasegTypes.CLEAR_FORM_QUOTE,
});

export const clearCompanyData = () => ({
  type: ConlicitasegTypes.CLEAR_COMPANY_DATA,
});

export const clearResumeProcess = () => ({
  type: ConlicitasegTypes.CLEAR_RESUME_PROCESS,
});

export const clearRequestState = () => ({
  type: ConlicitasegTypes.CLEAR_REQUEST_STATE,
});

export const clearSearchCompanyData = () => ({
  type: ConlicitasegTypes.CLEAR_SEARCH_COMPANY_DATA,
});

export const clearCompanyName = () => ({
  type: ConlicitasegTypes.CLEAR_COMPANY_NAME,
});

export const createQuoteJunto = (
  data: Partial<FormProcessData>,
  user_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  const {
    policyholder_register_sombrero,
    policyholder_register_junto,
    policyholder_register_avla,
    ...insuranceQuoteData
  } = data;

  return {
    types: [
      ConlicitasegTypes.CREATE_QUOTE_JUNTO_REQUEST,
      ConlicitasegTypes.CREATE_QUOTE_JUNTO_SUCCESS,
      ConlicitasegTypes.CREATE_QUOTE_JUNTO_FAILURE,
    ],
    promise: (client: any) =>
      client.post('/conlicitaseg/insurance_quotes', {
        insurance_quote: { ...insuranceQuoteData, status: 'cotacao' },
        user_id,
        client_id,
        insurance_company_id: 'junto',
        insurance_process_id,
        policyholder_register_junto,
        policyholder_register_sombrero,
        policyholder_register_avla,
      }),
    insurance_company_id: 'junto' as InsuranceCompany,
  };
};

export const createQuoteSombrero = (
  data: Partial<FormProcessData>,
  user_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  const {
    policyholder_register_sombrero,
    policyholder_register_junto,
    policyholder_register_avla,
    ...insuranceQuoteData
  } = data;

  return {
    types: [
      ConlicitasegTypes.CREATE_QUOTE_SOMBRERO_REQUEST,
      ConlicitasegTypes.CREATE_QUOTE_SOMBRERO_SUCCESS,
      ConlicitasegTypes.CREATE_QUOTE_SOMBRERO_FAILURE,
    ],
    promise: (client: any) =>
      client.post('/conlicitaseg/insurance_quotes', {
        insurance_quote: { ...insuranceQuoteData, status: 'cotacao' },
        user_id,
        client_id,
        insurance_company_id: 'sombrero',
        insurance_process_id,
        policyholder_register_junto,
        policyholder_register_sombrero,
        policyholder_register_avla,
      }),
    insurance_company_id: 'sombrero' as InsuranceCompany,
  };
};

export const createQuoteAvla = (
  data: Partial<FormProcessData>,
  user_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  const {
    policyholder_register_sombrero,
    policyholder_register_junto,
    policyholder_register_avla,
    ...insuranceQuoteData
  } = data;

  return {
    types: [
      ConlicitasegTypes.CREATE_QUOTE_AVLA_REQUEST,
      ConlicitasegTypes.CREATE_QUOTE_AVLA_SUCCESS,
      ConlicitasegTypes.CREATE_QUOTE_AVLA_FAILURE,
    ],
    promise: (client: any) =>
      client.post('/conlicitaseg/insurance_quotes', {
        insurance_quote: { ...insuranceQuoteData, status: 'cotacao' },
        user_id,
        client_id,
        insurance_company_id: 'avla',
        insurance_process_id,
        policyholder_register_junto,
        policyholder_register_sombrero,
        policyholder_register_avla,
      }),
    insurance_company_id: 'avla' as InsuranceCompany,
  };
};

export const createQuotePottencial = (
  data: Partial<FormProcessData>,
  user_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  const {
    policyholder_register_sombrero,
    policyholder_register_junto,
    policyholder_register_avla,
    ...insuranceQuoteData
  } = data;

  return {
    types: [
      ConlicitasegTypes.CREATE_QUOTE_POTTENCIAL_REQUEST,
      ConlicitasegTypes.CREATE_QUOTE_POTTENCIAL_SUCCESS,
      ConlicitasegTypes.CREATE_QUOTE_POTTENCIAL_FAILURE,
    ],
    promise: (client: any) =>
      client.post('/conlicitaseg/insurance_quotes', {
        insurance_quote: { ...insuranceQuoteData, status: 'cotacao' },
        user_id,
        client_id,
        insurance_company_id: 'pottencial',
        insurance_process_id,
        policyholder_register_junto,
        policyholder_register_sombrero,
        policyholder_register_avla,
      }),
    insurance_company_id: 'pottencial' as InsuranceCompany,
  };
};

export const createProcess = (data: FormProcessData) => ({
  types: [
    ConlicitasegTypes.CREATE_PROCESS_REQUEST,
    ConlicitasegTypes.CREATE_PROCESS_SUCCESS,
    ConlicitasegTypes.CREATE_PROCESS_FAILURE,
  ],
  promise: (client: any) =>
    client.post('/conlicitaseg/insurance_processes', {
      data,
    }),
});

export const clearQuotesByCompany = () => ({
  type: ConlicitasegTypes.CLEAR_QUOTES_BY_COMPANY,
});

export const setResumeProcess = (resume: boolean) => ({
  type: ConlicitasegTypes.SET_RESUME_PROCESS,
  payload: resume,
});

export const setSelectedQuoteStore = (quote: InsuranceQuote) => ({
  type: ConlicitasegTypes.SET_SELECTED_QUOTE_STORE,
  payload: quote,
});

export const setPaymentInfo = (paymentData: Partial<InsuranceQuote>) => ({
  type: ConlicitasegTypes.SET_PAYMENT_INFO,
  payload: paymentData,
});

export const submitQuoteWithPayment = (quoteData: SubimitQuote) => ({
  types: [
    ConlicitasegTypes.SUBMIT_QUOTE_WITH_PAYMENT_REQUEST,
    ConlicitasegTypes.SUBMIT_QUOTE_WITH_PAYMENT_SUCCESS,
    ConlicitasegTypes.SUBMIT_QUOTE_WITH_PAYMENT_FAILURE,
  ],
  promise: (client: any) =>
    client.post('/conlicitaseg/insurance_quotes/proposal_confirmation', quoteData),
  quoteData,
});

export const searchCompanyData = (policyholder_cnpj: string, policyholder_cnpj_matriz: string) => ({
  types: [
    ConlicitasegTypes.SEARCH_COMPANY_DATA_REQUEST,
    ConlicitasegTypes.SEARCH_COMPANY_DATA_SUCCESS,
    ConlicitasegTypes.SEARCH_COMPANY_DATA_FAILURE,
  ],
  promise: (client: any) =>
    client.post('/conlicitaseg/insurance_quotes/register_policyholder', {
      policyholder_cnpj,
      policyholder_cnpj_matriz,
    }),
});

export const createProposal = (
  selected_api_quote_id: string,
  insurance_company_id: string,
  proposal_id: string,
  insurance_process_id: number,
) => {
  const requestData: any = {
    insurance_company_id,
  };

  switch (insurance_company_id) {
    case 'junto':
    case 'sombrero':
    case 'avla':
      requestData.selected_api_quote_id = selected_api_quote_id;
      break;
    case 'pottencial':
      requestData.proposal_id = proposal_id;
      break;
    default:
      break;
  }

  return {
    types: [
      ConlicitasegTypes.CREATE_PROPOSAL_REQUEST,
      ConlicitasegTypes.CREATE_PROPOSAL_SUCCESS,
      ConlicitasegTypes.CREATE_PROPOSAL_FAILURE,
    ],
    selected_api_quote_id,
    insurance_process_id,
    promise: (client: any) =>
      client.post('/conlicitaseg/insurance_quotes/create_proposal', requestData),
  };
};

export const getInsured = (insured_cnpj_or_company_name: string) => ({
  types: [
    ConlicitasegTypes.GET_INSURED_REQUEST,
    ConlicitasegTypes.GET_INSURED_SUCCESS,
    ConlicitasegTypes.GET_INSURED_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/conlicitaseg/insurance_quotes/get_insured', {
      params: { insured_cnpj_or_company_name },
    }),
});

export const updateQuoteJunto = (
  data: Partial<InsuranceProcess>,
  contact_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  return {
    types: [
      ConlicitasegTypes.UPDATE_QUOTE_JUNTO_REQUEST,
      ConlicitasegTypes.UPDATE_QUOTE_JUNTO_SUCCESS,
      ConlicitasegTypes.UPDATE_QUOTE_JUNTO_FAILURE,
    ],
    promise: (client: any) =>
      client.put(`/conlicitaseg/insurance_quotes/${insurance_process_id}`, {
        insurance_quote: { ...data, status: 'cotacao' },
        contact_id,
        client_id,
        insurance_company_id: 'junto',
        insurance_process_id,
      }),
    insurance_company_id: 'junto' as InsuranceCompany,
  };
};

export const updateQuotePottencial = (
  data: Partial<FormProcessData>,
  contact_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  return {
    types: [
      ConlicitasegTypes.UPDATE_QUOTE_POTTENCIAL_REQUEST,
      ConlicitasegTypes.UPDATE_QUOTE_POTTENCIAL_SUCCESS,
      ConlicitasegTypes.UPDATE_QUOTE_POTTENCIAL_FAILURE,
    ],
    promise: (client: any) =>
      client.put(`/conlicitaseg/insurance_quotes/${insurance_process_id}`, {
        insurance_quote: { ...data, status: 'cotacao' },
        contact_id,
        client_id,
        insurance_company_id: 'pottencial',
        insurance_process_id,
      }),
    insurance_company_id: 'pottencial' as InsuranceCompany,
  };
};

export const updateQuoteSombrero = (
  data: Partial<FormProcessData>,
  contact_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  return {
    types: [
      ConlicitasegTypes.UPDATE_QUOTE_SOMBRERO_REQUEST,
      ConlicitasegTypes.UPDATE_QUOTE_SOMBRERO_SUCCESS,
      ConlicitasegTypes.UPDATE_QUOTE_SOMBRERO_FAILURE,
    ],
    promise: (client: any) =>
      client.put(`/conlicitaseg/insurance_quotes/${insurance_process_id}`, {
        insurance_quote: { ...data, status: 'cotacao' },
        contact_id,
        client_id,
        insurance_company_id: 'sombrero',
        insurance_process_id,
      }),
    insurance_company_id: 'sombrero' as InsuranceCompany,
  };
};

export const updateQuoteAvla = (
  data: Partial<FormProcessData>,
  contact_id: number,
  client_id: number,
  insurance_process_id: number,
) => {
  return {
    types: [
      ConlicitasegTypes.UPDATE_QUOTE_AVLA_REQUEST,
      ConlicitasegTypes.UPDATE_QUOTE_AVLA_SUCCESS,
      ConlicitasegTypes.UPDATE_QUOTE_AVLA_FAILURE,
    ],
    promise: (client: any) =>
      client.put(`/conlicitaseg/insurance_quotes/${insurance_process_id}`, {
        insurance_quote: { ...data, status: 'cotacao' },
        contact_id,
        client_id,
        insurance_company_id: 'avla',
        insurance_process_id,
      }),
    insurance_company_id: 'avla' as InsuranceCompany,
  };
};

export const setSecondQuoteTry = (quote_try: boolean) => ({
  type: ConlicitasegTypes.SET_SECOND_QUOTE_TRY,
  payload: quote_try,
});

export const clearSecondQuoteTry = () => ({
  type: ConlicitasegTypes.CLEAR_SECOND_QUOTE_TRY,
});

export const clearCurrentProcessId = () => ({
  type: ConlicitasegTypes.CLEAR_CURRENT_PROCESS_ID,
});

export const getClientPolicyholders = () => ({
  types: [
    ConlicitasegTypes.GET_CLIENT_POLICYHOLDERS_REQUEST,
    ConlicitasegTypes.GET_CLIENT_POLICYHOLDERS_SUCCESS,
    ConlicitasegTypes.GET_CLIENT_POLICYHOLDERS_FAILURE,
  ],
  promise: (client: any) => client.get('/conlicitaseg/client_policyholders'),
});

export const createClientPolicyholder = (cnpj: string) => ({
  types: [
    ConlicitasegTypes.CREATE_CLIENT_POLICYHOLDER_REQUEST,
    ConlicitasegTypes.CREATE_CLIENT_POLICYHOLDER_SUCCESS,
    ConlicitasegTypes.CREATE_CLIENT_POLICYHOLDER_FAILURE,
  ],
  cnpj,
  promise: (client: any) => client.post('/conlicitaseg/client_policyholders', { cnpj }),
});

export const getCompanyName = (policyholder_cnpj: string) => ({
  types: [
    ConlicitasegTypes.GET_COMPANY_NAME_REQUEST,
    ConlicitasegTypes.GET_COMPANY_NAME_SUCCESS,
    ConlicitasegTypes.GET_COMPANY_NAME_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/conlicitaseg/insurance_quotes/get_company_name', {
      params: {
        policyholder_cnpj,
      },
    }),
});
